import React from "react";
import {
  Box,
  Button,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import { PRIMARY_ORANGE } from "./constants";

const controlRadius = "6px";

const PageToolbar = ({
  searchValue = "",
  onSearchChange,
  onSearchSubmit,
  searchPlaceholder = "Search...",
  showSearch = true,
  showFilters = true,
  onFiltersClick,
  filterActive = false,
  createLabel,
  onCreateClick,
  extraActions,
  embedded = false,
}) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    onSearchSubmit?.(event);
  };

  return (
    <Box
      className="page-toolbar"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        flexWrap: "wrap",
        gap: 1.5,
        mb: embedded ? 0 : 2.5,
        flex: embedded ? "0 1 auto" : undefined,
      }}
    >
      {extraActions}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        {showSearch && (
          <OutlinedInput
            size="small"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={(e) => onSearchChange?.(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <SearchIcon sx={{ fontSize: 18, color: "text.secondary" }} />
              </InputAdornment>
            }
            sx={{
              minWidth: { xs: 200, sm: 260 },
              borderRadius: controlRadius,
              bgcolor: "#fff",
              fontSize: "0.875rem",
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e0e0e0" },
              "& .MuiOutlinedInput-input": { py: 0.85 },
            }}
          />
        )}
        {showFilters && (
          <Button
            variant="outlined"
            startIcon={<FilterListIcon />}
            onClick={onFiltersClick}
            sx={{
              borderColor: filterActive ? PRIMARY_ORANGE : "#e0e0e0",
              color: filterActive ? PRIMARY_ORANGE : "text.primary",
              bgcolor: "#fff",
              textTransform: "none",
              borderRadius: controlRadius,
              px: 1.75,
              py: 0.65,
              fontSize: "0.875rem",
              boxShadow: "none",
            }}
          >
            Filters
          </Button>
        )}
        {createLabel && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onCreateClick}
            sx={{
              bgcolor: PRIMARY_ORANGE,
              textTransform: "none",
              borderRadius: controlRadius,
              px: 1.75,
              py: 0.65,
              fontSize: "0.875rem",
              boxShadow: "none",
              whiteSpace: "nowrap",
              "&:hover": { bgcolor: "#f4511e", boxShadow: "none" },
            }}
          >
            {createLabel}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default PageToolbar;
